/**
 * Shared, non-component utilities for the onboarding wizard.
 *
 * Split from onboardingWizard.jsx so React Fast Refresh stays happy
 * (it requires a JSX module to export only components).
 */

export const EMPTY_PAYLOAD = {
  schemaVersion: 'v1',
  contact: { firstName: '', lastName: '', email: '', phone: '', address: '' },
  vehicle: {
    plate: '',
    vehicleName: '',
    make: '',
    model: '',
    year: '',
    color: '',
  },
  agreedToTerms: false,
};

export function mergePayload(base, patch) {
  // Drops the legacy `registration` block from older personal-invite drafts —
  // the agreement now lives at the top level (`agreedToTerms`).
  const { registration: _legacyRegistration, ...rest } = patch || {};
  void _legacyRegistration;
  return {
    ...base,
    ...rest,
    contact: { ...base.contact, ...(rest?.contact || {}) },
    vehicle: { ...base.vehicle, ...(rest?.vehicle || {}) },
    agreedToTerms:
      typeof rest?.agreedToTerms === 'boolean'
        ? rest.agreedToTerms
        : base.agreedToTerms,
  };
}

export function errMessage(err, fallback = 'Something went wrong') {
  return (
    err?.response?.data?.message ||
    (Array.isArray(err?.response?.data?.errors) &&
      err.response.data.errors.map((e) => e.message).join('; ')) ||
    err?.message ||
    fallback
  );
}
